module.exports = ".top-buffer{\n    margin-top: 5px;\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/broker/transfer-employer-close-office/search-employees/search-employees.component.css
// module id = ./src/app/broker/transfer-employer-close-office/search-employees/search-employees.component.css
// module chunks = main